import "./App.css";
import { Envelope } from "phosphor-react";
import { useEffect } from "react";
import project3 from "./assets/project3.jpg";
import project8 from "./assets/project8.png";
import project9 from "./assets/project9.gif";
import project10 from "./assets/project10.jpg";
import projectPianly from "./assets/project-pianly.png";
import projectFightWatch from "./assets/project-fight-watch.png";
import projectSense from './assets/projectsense.png'
import Lenis from "lenis";

function App() {
  // Slide Elements
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slideLeft1");
        } else {
          entry.target.classList.remove("slideLeft1");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".noSlideLeft1");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    // Cleanup function
    return () => {
      hiddenElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []); // Empty dependency array to run the effect only once after initial render

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slideLeft2");
        } else {
          entry.target.classList.remove("slideLeft2");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".noSlideLeft2");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    // Cleanup function
    return () => {
      hiddenElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []); // Empty dependency array to run the effect only once after initial render

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slideLeft3");
        } else {
          entry.target.classList.remove("slideLeft3");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".noSlideLeft3");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    // Cleanup function
    return () => {
      hiddenElements.forEach((element) => { observer.unobserve(element); });
    };
  }, []); // Empty dependency array to run the effect only once after initial render

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => { entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slideRight"); } else {
          entry.target.classList.remove("slideRight");
        }
      }); });
const hiddenElements = document.querySelectorAll(".noSlideRight");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });
    return () => { hiddenElements.forEach((element) => {
        observer.unobserve(element);
      }); };
  }, []);
useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("slideRight");
        } else {
          entry.target.classList.remove("slideRight"); }
      }); });

    const hiddenElements = document.querySelectorAll(".noSlideRight"); hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      hiddenElements.forEach((element) => { observer.unobserve(element);
      });
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => { entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(".hidden");
    hiddenElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {
      hiddenElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  const socialIcons = [
    {
      link: "https://www.linkedin.com/in/francisco-figueroa-73a9941b6/",
      class: "devicon-linkedin-plain",
    },
    {
      link: "https://github.com/FranThe3rd",
      class: "devicon-github-original",
    },
  ];

  const techCategories = [
    {
      title: "Frontend",
      skills: [
        {
          name: "HTML",
          class: "devicon-html5-plain-wordmark colored",
        },
        {
          name: "React",
          class: "devicon-react-original colored",
        },
      ],
    },
    {
      title: "Database",
      skills: [
        {
          name: "PostgreSQL",
          class: "devicon-postgresql-plain-wordmark colored",
        },
        {
          name: "MySQL",
          class: "devicon-mysql-plain-wordmark colored",
        },
      ],
    },
    {
      title: "Languages",
      skills: [
        {
          name: "JavaScript",
          class: "devicon-javascript-plain colored",
        },
        {
          name: "Java",
          class: "devicon-java-plain-wordmark colored",
        },
        {
          name: "Python",
          class: "devicon-python-plain-wordmark colored",
        },
        {
          name: "C++",
          class: "devicon-cplusplus-plain colored",
        },
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Spring Boot",
          class: "devicon-spring-plain-wordmark colored",
        },
        {
          name: "Node.js",
          class: "devicon-nodejs-plain-wordmark colored",
        },
      ],
    },
    {
      title: "Tools",
      skills: [
        {
          name: "Git",
          class: "devicon-git-plain-wordmark colored",
        },
        {
          name: "AWS",
          class: "devicon-amazonwebservices-plain-wordmark colored",
        },
      ],
    },
  ];

  useEffect(() => {
    const lenis = new Lenis();

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  });

  return (
    <div className="App">
      <div className="app-container">
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/devicon.min.css"
        />

        <div className="navbar">
          <h1>F F</h1>
          <div className="icons">
            {socialIcons.map((icon) => {
              return (
                <a href={icon.link} target="_blank" rel="noreferrer">
                  <i className={icon.class}></i>
                </a>
              );
            })}
            <a href="mailto:francisco.figueroa.dev@gmail.com">
              <Envelope size={32} />
            </a>
          </div>
        </div>

        <div className="app-hero-grid">
          <div className="app-hero-text noSlideLeft1">
            <h1>Francisco Figueroa</h1>
            <h2>Computer Science Student</h2>
            <p>
    Hello, I’m a Computer Science student at Moravian University with hands-on experience building modern web applications. My primary expertise lies in developing responsive, interactive websites using React. I also have experience working with full-stack technologies such as PostgreSQL, Spring Boot, and AWS. I’m passionate about turning ideas into functional, user-friendly web applications and am actively seeking opportunities to contribute to real-world projects through a tech internship.
            </p>
          </div>
          <div className="app-hero-image">
            <div className="blob "></div>
          </div>
        </div>
      </div>

      <div className="tech">
        <h1 className="hidden">Technologies</h1>
        <div className="tech-stack hidden">
          {techCategories.map((category) => (
            <div className="tech-category" key={category.title}>
              <h3 className="tech-category-title">{category.title}</h3>
              <div className="tech-category-icons">
                {category.skills.map((skill) => (
                  <div className="tech-skill" key={skill.name} title={skill.name}>
                    <i className={skill.class} aria-hidden="true"></i>
                    <span>{skill.name}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="experience">
        <h1 className="hidden">Experience</h1>
        <div className="experience-grid">
          <div className="date">
            <h3 className="noSlideLeft2">July 2026 – Present</h3>
          </div>
          <div className="experience-text noSlideRight">
            <h3 className="hidden">Rating &amp; Quoting Analyst</h3>
            <p className="italicText">Guardian Life · Full-time</p>
            <p className="experience-location hidden">
              Bethlehem, Pennsylvania · Hybrid
            </p>
            <p className="hidden">
              Responsible for reviewing insurance broker data sheets and transforming the
              provided information into standardized, accurate formats for CPS approval. This
              includes analyzing and validating plan and enrollment data, preparing rating and
              quoting information, and ensuring submissions meet internal requirements and
              approval standards.
            </p>
          </div>

          <div className="date">
            <h3 className="noSlideLeft2">July 2024 – September 2024</h3>
          </div>
          <div className="experience-text noSlideRight">
            <h3 className="hidden">Software Engineer Fellow </h3>
            <p className="italicText">Headstarter.co</p>
            <p className="hidden">
              • Developed five AI-focused projects over seven weeks, using Next.js for front-end development and integrating Firebase and Stripe for authentication and payments. Gained hands-on experience with OpenAI’s tools and APIs to build a production-ready SaaS application.<br /><br />

              • Served as the primary front-end developer on a two-person team, collaborating closely with a backend developer to deliver full-stack features and maintain consistent development workflows.<br /><br />

              • Contributed to the open-source freeCodeCamp project as part of a final group assignment, following best practices in collaborative development and version control.
            </p>

          </div>


        </div>
      </div>
      <div className="projects">
        <h1 className="hidden">Projects</h1>
        <div className="project-grid">


          

          {/** Project 1 — Fight Watch */}

          <div className="project-image noSlideLeft2">
            <img src={projectFightWatch} alt="Fight Watch homepage" />
          </div>

          <div className="project-text noSlideRight">
            <h2>Fight Watch</h2>
            <p id="super-bold">Work in Progress</p>

            <p>
              A full-stack MMA platform for looking up UFC fighters and comparing
              them through trading-card-style profiles. Users can search the
              database by name, weight, height, reach, stance, rank, and main
              ability. Each fighter has an overall rating and individual stats
              for strength, power, grappling, defense, speed, and cardio.

              <br />
              <br />

              The app currently includes fighter profiles, event listings, and
              Spin the Wheel, with fantasy features and pack opening planned
              for the future. Built with React and Vite on the frontend,
              Spring Boot on the backend, and PostgreSQL for data storage.
              Fighter, event, and fight data is collected from UFCStats and
              UFC.com, processed into CSV files, and imported into the database.
            </p>

            <div className="project-tech">
              <h4>React</h4>
              <h4>Vite</h4>
              <h4>Spring Boot</h4>
              <h4>PostgreSQL</h4>
              <h4>Web Scraping</h4>
              <h4>Motion</h4>
            </div>

            <div className="project-live">
              <a
                href="https://www.fightwatch.net/"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Live Demo</h4>
              </a>

                <h4 id="greyedOut">Github</h4>
            </div>
          </div>


          {/**Project 2 — Pianly */}

          <div className="project-image noSlideLeft2">
            <img src={projectPianly} alt="Pianly" />
          </div>
          <div className="project-text noSlideRight">
            <h2>Pianly</h2>
            <p>
              A full-stack piano learning web app that guides users through songs with real-time
              visual feedback, offering falling-note and sheet music views alongside an interactive
              on-screen piano. The MIDI-based practice engine uses Tone.js to parse and play songs,
              with missed-note detection, a no-pause mode, adjustable playback speed, and a smooth
              rewind-to-missed-note flow. The Spring Boot REST API uses JWT-based authentication via
              Spring Security and Stripe-powered subscription payments, deployed on Amazon EC2 with
              a PostgreSQL database hosted on Amazon RDS.
            </p>
            <div className="project-tech">
              <h4>React</h4>
              <h4>Tone.js</h4>
              <h4>Spring Boot</h4>
              <h4>PostgreSQL</h4>
              <h4>AWS</h4>
              <h4>Stripe</h4>
            </div>
            <div className="project-live">
              <h4 id="greyedOut">Live Demo</h4>
              <a
                href="https://github.com/FranThe3rd/Pianly"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>


          {/**Project 2 */}

          <div className="project-image noSlideLeft2">
            <img src={project10} alt="Mirrulations Search" />
          </div>
          <div className="project-text noSlideRight">
            <h2>Mirrulations Search</h2>
            <p>
              A secure search and download portal for the Mirrulations regulatory dataset,
              built to make Regulations.gov dockets easier to explore than the raw government
              APIs. Authenticated users can search docket titles, IDs, documents, comments,
              and extracted attachment text; filter by agency, docket type, year, date range,
              and CFR title or part; review matched docket metadata; save dockets into personal
              collections; and request downloadable exports of selected docket data.
            </p>
            <div className="project-tech">
              <h4>React</h4>
              <h4>Flask</h4>
              <h4>PostgreSQL</h4>
              <h4>OpenSearch</h4>
              <h4>AWS</h4>
            </div>
            <div className="project-live">
              <a href="https://dev.mirrulations.org/" target="_blank" rel="noreferrer">
                <h4>Live Demo</h4>
              </a>
              <a
                href="https://github.com/mirrulations/mirrulations-search"
                target="_blank" rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>


          {/**Project 2 */}


          
          <div className="project-image noSlideLeft2">
            <img src={project9} alt="project" />
          </div>
          <div className="project-text noSlideRight">
            <h2>Algo Vortex</h2>
            <p id="super-bold">50+ People Registered</p>
            <p>
Developed an AI-powered coding interview platform that simulates LeetCode-style technical interviews with an adaptive, conversational AI interviewer. Built the application as a cross-platform desktop app using Electron and a responsive React + TypeScript frontend. Integrated local LLMs through Ollama, enabling users to run AI interviewers directly on their own hardware without incurring cloud API costs. Implemented realistic voice-driven feedback and guidance using the ElevenLabs API and secured user authentication with Firebase.            </p>

            <div className="project-tech">
              <h4>React</h4>
              <h4>TypeScript</h4>
              <h4>Firebase</h4>
            </div>
            <div className="project-live">
              <a href="https://www.algovortex.net/" target="_blank" rel="noreferrer">
                <h4>Live Demo</h4>
              </a>
              <a
                href="https://github.com/FranThe3rd/AlgoVortex"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>

          {/**Project 5 */}

          <div className="project-image noSlideLeft2">
            <img src={project8} alt="project" />
          </div>
          <div className="project-text noSlideRight">
            <h2>UFC Insight</h2>
            <p>
              A full-stack web application for searching and viewing detailed
              UFC fighter profiles. Users can search fighters by name and access
              comprehensive details, including weight, height, stance, and date
              of birth. The application features a ReactJS frontend hosted on
              Amazon S3, a Spring Boot backend deployed on an EC2 instance, and
              a PostgreSQL database hosted on Amazon RDS.
            </p>
            <div className="project-tech">
              <h4>React</h4>
              <h4>PostgreSQL</h4>
              <h4>SpringBoot</h4>
              <h4>AWS</h4>
            </div>
            <div className="project-live">
              <h4 id="greyedOut">Live Demo</h4>
              <a
                href="https://github.com/FranThe3rd/UFC-Insight"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>

            {/**Project 3 */}

          
          <div className="project-image noSlideLeft2">
            <img src={projectSense} alt="project" />
          </div>
          <div className="project-text noSlideRight">
            <h2>World Sense</h2>
            <p>
This is a simple interactive, map-based platform that lets users explore real-world data from multiple trusted sources. Users can view crime statistics, restaurant locations, and electric vehicle points,. Built as a full-stack web application, it uses ASP.NET 9 for the backend, a ReactJS frontend, an API hosted on Azure Web App Service, and a database hosted on Azure SQL Server. The frontend is deployed on Vercel.
            </p>
            <div className="project-tech">
              <h4>React</h4>
              <h4>Microsoft SQL Server</h4>
              <h4>ASP.NET 9</h4>
              <h4>Azure</h4>
            </div>
            <div className="project-live">
              <h4 id="greyedOut">Live Demo</h4>
              <a
                href="https://github.com/FranThe3rd/WorldSense"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>


            {/**Project 4 */}




          <div className="project-image noSlideLeft2">
            <img src={project3} alt="project" />
          </div>
          <div className="project-text noSlideRight">
            <h2>Moravian Scheduler</h2>
            <p>
              A full-stack web application for searching and viewing Moravian University course listings.
              Students can filter Spring 2026 classes by professor, course code, day, department, LINC
              requirement, and title, all in a cleaner layout compared to AMOS. The application features a
              ReactJS frontend hosted on Amazon S3, a Spring Boot backend running on an EC2 instance, and a
              PostgreSQL database hosted on Amazon RDS.

            </p>

            
            <div className="project-tech">
              <h4>React</h4>
              <h4>PostgreSQL</h4>
              <h4>SpringBoot</h4>
              <h4>AWS</h4>
            </div>
            <div className="project-live">
              <h4 id="greyedOut">Live Demo</h4>
              <a
                href="https://github.com/FranThe3rd/Moravian-Scheduler"
                target="_blank"
                rel="noreferrer"
              >
                <h4>Github</h4>
              </a>
            </div>
          </div>





          

        </div>
      </div>
    </div>
  );
}

export default App;
